// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import {chatFrameHandler} from "../../../Assets/Js/ChatFrameHandler";

require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

import * as helper from './../../../Assets/Js/helper';

import {animateTimer} from "./Timer";
import {ClipHandler} from "./ClipHandler";
import {ImageHover} from "./ImageHover";
import {FontAwesomeLoader} from "./FontAwesomeLoader";
import {VideoHandler} from "./VideoHandler";
import {PaytourHandler} from "./PaytourHandler";
import {ImprintHandler} from "./ImprintHandler";
import {initMobileMenu} from "../../../Assets/Js/VXProductLight/MobileMenu";
import {initCookieBanner} from "../../../Assets/Js/VXProductLight/CookieBanner";

helper.onWindowLoadedCompletely(() => {
	const timer = helper.$('.timer');
	const welcomeClips = helper.$('#welcomeclips');
	const models = document.querySelectorAll<HTMLDivElement>('.model');
	const ab3 = parseInt(helper.getData(helper.$('#wrapper'), 'ab3'));

	initCookieBanner();
	initMobileMenu();
	FontAwesomeLoader();
	VideoHandler();
	PaytourHandler();
	ImageHover(models);
	animateTimer(timer);
	ClipHandler(welcomeClips);
	ImprintHandler();
	chatFrameHandler(ab3);
})
